(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cav-vertical-video-carousel"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('.cav-vertical-video-carousel');

  sections.forEach((section) => {
    const track = section.querySelector('[data-cav-track]');
    const slides = Array.from(section.querySelectorAll('[data-cav-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-cav-dot]'));
    const prev = section.querySelector('[data-cav-prev]');
    const next = section.querySelector('[data-cav-next]');

    if (!track || slides.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getActiveIndex = () => {
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;
        const distance = Math.abs(trackCenter - slideCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const scrollToIndex = (index) => {
      const slide = slides[index];
      if (!slide) return;
      const left = slide.offsetLeft - track.offsetLeft;
      track.scrollTo({
        left,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    };

    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    };

    const pauseAllVideos = () => {
      slides.forEach((slide) => {
        const videos = slide.querySelectorAll('video');
        videos.forEach((video) => {
          if (!video.paused) {
            video.pause();
          }
        });
      });
    };

    const playVideo = (video) => {
      if (!video) return;
      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            video.controls = true;
          });
        }
      };
      pauseAllVideos();
      if (video.readyState === 0) {
        video.load();
      }
      if (video.readyState >= 2) {
        tryPlay();
      } else {
        const onReady = () => {
          video.removeEventListener('loadeddata', onReady);
          tryPlay();
        };
        video.addEventListener('loadeddata', onReady);
      }
    };

    const toggleVideo = (video) => {
      if (!video) return;
      if (video.paused) {
        playVideo(video);
      } else {
        video.pause();
      }
    };

    const updateActiveState = () => {
      const activeIndex = getActiveIndex();
      if (dots.length > 0) {
        setActiveDot(activeIndex);
      }
    };

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateActiveState);
    });

    if (prev) {
      prev.addEventListener('click', () => {
        scrollToIndex(Math.max(0, getActiveIndex() - 1));
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        scrollToIndex(Math.min(slides.length - 1, getActiveIndex() + 1));
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => scrollToIndex(index));
    });

    slides.forEach((slide) => {
      const frame = slide.querySelector('.cav-vertical-video-carousel__video-frame');
      const video = slide.querySelector('video');
      const playButton = slide.querySelector('[data-cav-play]');
      if (!frame || !video || !playButton) return;
      frame.setAttribute('tabindex', '0');
      playButton.addEventListener('click', (event) => {
        event.stopPropagation();
        toggleVideo(video);
      });
      frame.addEventListener('click', () => toggleVideo(video));
      frame.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleVideo(video);
        }
      });

      video.addEventListener('play', () => {
        frame.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        frame.classList.remove('is-playing');
      });

      video.addEventListener('ended', () => {
        frame.classList.remove('is-playing');
      });
    });

    updateActiveState();

    const firstSlide = slides[0];
    const firstVideo = firstSlide ? firstSlide.querySelector('video') : null;

    if (firstVideo) {
      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo(firstVideo);
            sectionObserver.disconnect();
          }
        });
      }, { threshold: 0.5 });
      sectionObserver.observe(section);
    }

    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (!video) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !video.paused) {
            video.pause();
          }
        });
      }, { root: null, threshold: 0.1 });
      observer.observe(slide);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* --- Countdown timer --- */
    var countdownElements = document.querySelectorAll('[id^="Countdown-"]');

    countdownElements.forEach(function(countdown) {
      var targetDateStr = countdown.dataset.target;
      if (!targetDateStr) return;

      var targetDate = new Date(targetDateStr);
      var daysEl = countdown.querySelector('[data-days]');
      var hoursEl = countdown.querySelector('[data-hours]');
      var minsEl = countdown.querySelector('[data-mins]');
      var secsEl = countdown.querySelector('[data-secs]');

      function padZero(num) {
        return num.toString().padStart(2, '0');
      }

      function updateCountdown() {
        var now = new Date();
        var diff = targetDate - now;

        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minsEl.textContent = '00';
          secsEl.textContent = '00';
          return;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var secs = Math.floor((diff % (1000 * 60)) / 1000);

        daysEl.textContent = padZero(days);
        hoursEl.textContent = padZero(hours);
        minsEl.textContent = padZero(mins);
        secsEl.textContent = padZero(secs);
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });

    /* --- Emoji celebration --- */
    function launchEmojiCelebration(container) {
      var emojis = ['\uD83C\uDF89', '\uD83E\uDD73', '\uD83C\uDF8A', '\uD83C\uDF7E', '\uD83C\uDF88', '\uD83E\uDEA9', '\uD83C\uDF86', '\uD83D\uDE4C'];
      var count = 30;
      for (var i = 0; i < count; i++) {
        var el = document.createElement('span');
        el.className = 'emoji-particle';
        el.textContent = emojis[Math.floor(Math.random() * emojis.length)];
        el.style.left = Math.random() * 100 + '%';
        el.style.animationDelay = (Math.random() * 0.6) + 's';
        el.style.fontSize = (18 + Math.random() * 18) + 'px';
        container.appendChild(el);
      }
      setTimeout(function() {
        var particles = container.querySelectorAll('.emoji-particle');
        for (var j = 0; j < particles.length; j++) {
          particles[j].remove();
        }
      }, 3500);
    }

    /* --- RSVP form handler --- */
    var rsvpForms = document.querySelectorAll('.events-featured__rsvp-form');

    rsvpForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var webhookUrl = form.dataset.webhookUrl;
        var eventTitle = form.dataset.eventTitle || '';
        var emailInput = form.querySelector('input[name="email"]');
        var btn = form.querySelector('.events-featured__button');
        var errorEl = form.querySelector('.events-featured__form-error');
        var wrap = form.closest('.events-featured__rsvp-wrap');
        var successDiv = wrap.querySelector('.events-featured__success');

        var email = emailInput.value.trim();

        errorEl.style.display = 'none';
        errorEl.textContent = '';

        if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 3) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.style.display = 'block';
          return;
        }

        if (!webhookUrl) {
          errorEl.textContent = 'RSVP is not configured yet. Please try again later.';
          errorEl.style.display = 'block';
          return;
        }

        btn.classList.add('is-loading');

        fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            event_title: eventTitle,
            timestamp: new Date().toISOString()
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Network error');
          form.style.display = 'none';
          successDiv.style.display = 'block';
          launchEmojiCelebration(wrap);
        })
        .catch(function() {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.style.display = 'block';
        })
        .finally(function() {
          btn.classList.remove('is-loading');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
